import { connect } from 'react-redux'
import UI from './UI'
import { addToFavorite, removeFromFavorite, changeFollowStateAction } from 'pages/Course/store'
import { AddItemToCartAction } from 'components/Cart/store'

const mapStateToProps = ({ user, identity, course, referential }) => ({
  isConnected: identity.isConnected,
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  IsFavorite: course.Course.IsFavorite,
  IsAccessible: course?.Course?.IsAccessible,
  loading: course.gettingCoursesInfos,
  IsFree: course.Course.IsFree
})

const mapDispatchToProps = dispatch => ({
  addToCart: course => dispatch(AddItemToCartAction(course)),
  addToFavorite: _ => dispatch(addToFavorite()),
  removeFromFavorite: _ => dispatch(removeFromFavorite()),
  changeFollowState: _ => dispatch(changeFollowStateAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
